import React, {useState} from 'react'
import Moment from 'moment'
import clsx from 'clsx'
import {extendMoment} from 'moment-range'

import {DatePicker} from '@material-ui/pickers'

import {Grid, IconButton, withStyles} from '@material-ui/core'
import Utils from 'EurestoFonction/Utils'
import Input from 'Components/Input'

const moment = extendMoment(Moment)

moment.locale('fr')

const styles = theme => ({
  dayWrapper: {
    position: 'relative',
  },
  day: theme.overrides.MuiPickersDay.day,
  customDayHighlight: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '2px',
    right: '2px',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: 5,
  },
  isSelected: theme.overrides.MuiPickersDay.isSelected,
  nonCurrentMonthDay: {
    color: 'transparent',
    border: 'none',
    cursor: 'unset',
    '&:hover': {
      backgroundColor: 'transparent',
      cursor: 'unset',
    }
  },
  highlight: {
    background: theme.palette.primary.main,
  },
  firstHighlight: {
    extend: 'highlight',
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
  },
  endHighlight: {
    extend: 'highlight',
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
  },
  highlightNonCurrentMonthDay: {
    color: 'grey',
  },
  isDisabled: theme.overrides.MuiPickersDay.isDisabled
})

export default withStyles(styles)((props) => {
  let startD, endD, setDate
  if (props.range || props.week || props.year || props.month) {
    [[startD, endD], setDate] = useState(props.value || [undefined, undefined])
  } else {
    [startD, setDate] = useState(props.value || undefined)
  }
  const key = Utils.getRandomNumber()
  const [open, setOpen] = useState(props.open || false)
  const [inputKey, setinputKey] = useState(Utils.getRandomNumber())

  const shouldDisableDate = (date) => {
    return (props.disableDate || []).indexOf(date.format('YYYY-MM-DD')) !== -1
  }

  const renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {
    const {classes} = props

    const today = moment()
    const [startDate, endDate] = props.value || [today, undefined]

    const start = moment(startDate, 'YYYY-MM-DD 00:00:00')
    const end = moment(endDate || startDate, 'YYYY-MM-DD 23:59:59')
    const range = moment.range(start, end)
    const dayIsBetween = range.contains(date)
    const isFirstDay = dayIsBetween && date.isSame(start)
    const isLastDay = dayIsBetween && date.isSame(end)

    const wrapperClassName = clsx({
      [classes.highlight]: dayIsBetween,
      [classes.firstHighlight]: isFirstDay,
      [classes.endHighlight]: isLastDay,
    })

    const dayClassName = clsx(classes.day, {
      [classes.isSelected]: dayInCurrentMonth && dayIsBetween,
      [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
      [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween,
      [classes.isDisabled]: dayInCurrentMonth && props.disablePast && moment(date, 'YYYY-MM-DD 00:00:00').isBefore(moment(today, 'YYYY-MM-DD 23:59:59'))
      || dayInCurrentMonth && props.disableFuture && moment(date, 'YYYY-MM-DD 00:00:00').isAfter(moment(today, 'YYYY-MM-DD 23:59:59'))
      || dayInCurrentMonth && props.minDate && moment(date, 'YYYY-MM-DD 00:00:00').isBefore(moment(props.minDate, 'YYYY-MM-DD HH:mm:ss'))
      || dayInCurrentMonth && props.maxDate && moment(date, 'YYYY-MM-DD 00:00:00').isAfter(moment(props.maxDate, 'YYYY-MM-DD HH:mm:ss'))
    })

    return (
        <div className={wrapperClassName}>
          <IconButton className={dayClassName}>
            <span> {date.format('DD')} </span>
          </IconButton>
        </div>
    )
  }

  const onChange = (date, a, b, c) => {
    if (props.range) {
      let [startDate, endDate] = props.value || [undefined, undefined]
      if (!endDate && startDate && date.isSameOrAfter(startDate)) {
        endDate = date.format('YYYY-MM-DD')
      } else {
        startDate = date.format('YYYY-MM-DD')
        endDate = !props.range && startDate || undefined
      }
      setDate([startDate, endDate])
      if (startDate && endDate) {
        setinputKey(Utils.getRandomNumber())
      }
      props.onChange && props.onChange([startDate, endDate], props.name)
    } else if (props.week) {
      const startDate = date.startOf('week').format('YYYY-MM-DD')
      const endDate = date.endOf('week').format('YYYY-MM-DD')
      setDate([startDate, endDate])
      setinputKey(Utils.getRandomNumber())
      props.onChange && props.onChange([startDate, endDate], props.name)
    } else if (props.year) {
      const startDate = date.startOf('year').format('YYYY-MM-DD')
      const endDate = date.endOf('year').format('YYYY-MM-DD')
      setDate([startDate, endDate])
      setinputKey(Utils.getRandomNumber())
      props.onChange && props.onChange([startDate, endDate], props.name)
    } else if (props.month) {
      const startDate = moment(startD).set('month', date.month()).startOf('month').format('YYYY-MM-DD')
      const endDate = moment(startD).set('month', date.month()).endOf('month').format('YYYY-MM-DD')
      setDate([startDate, endDate])
      setinputKey(Utils.getRandomNumber())
      props.onChange && props.onChange([startDate, endDate], props.name)
    } else {
      setDate(date.format('YYYY-MM-DD'))
      setinputKey(Utils.getRandomNumber())
      props.onChange && props.onChange(date.format('YYYY-MM-DD'), props.name)
    }
  }

  const clearDate = () => {
    if (props.range || props.week || props.year || props.month) {
      setDate([undefined, undefined])
    } else {
      setDate(undefined)
    }
    setinputKey(Utils.getRandomNumber())
    props.onChange && props.onChange(undefined, props.name)
  }

  const formatWeekSelectLabel = (date, invalidLabel) => {
    if (props.range || props.week) {
      return startD && (moment(startD, 'YYYY-MM-DD').format('DD/MM/YY') + (endD && !(moment(startD, 'YYYY-MM-DD').isSame(moment(endD, 'YYYY-MM-DD'))) && (' - ' + moment(endD, 'YYYY-MM-DD').format('DD/MM/YY')) || '')) || ''
    } else if (props.year) {
      return moment(startD, 'YYYY-MM-DD').format(props.formatLibelle || 'YYYY') + (props.scolaire ? '/'+moment(startD, 'YYYY-MM-DD').add(1, 'year').format(props.formatLibelle || 'YYYY') : '')
    } else if (props.month) {
      return moment(startD, 'YYYY-MM-DD').format(props.formatLibelle || 'MMMM YYYY')
    } else {
      return startD && moment(startD, 'YYYY-MM-DD').format(props.formatLibelle || 'dddd DD MMMM YYYY') || ''
    }
  }

  const onMonthChange = (date) => {
    console.debug(date)
  }

  const datePicker = <Grid container style={{
    position: 'relative',
    marginBottom: 5,
    ...(props.style || {})
  }} alignItems={'stretch'} direction={'column'}
                           justify={'center'}>
    <DatePicker
        views={[`year`, `month`, `date`]}
        openTo={props.year && 'year' || props.month && 'month' || `date`}
        key={inputKey}
        disableToolbar
        variant="inline"
        style={{textAlign: 'center'}}
        id={(props.id || 'openPicker') + '_' + key}
        onMonthChange={onMonthChange}
        disabled={props.disabled}
        disablePast={props.disablePast}
        disableFuture={props.disableFuture}
        inputVariant="outlined"
        InputProps={{
          ...(props.InputProps || {}),
          style: {
            marginBottom: 0,
            ...(props.InputProps && props.InputProps.style || {}),
            textAlign: 'center'
          },
        }}
        open={open}
        inputValue={formatWeekSelectLabel()}
        TextFieldComponent={Input}
        onOpen={_ => setOpen(true)}
        onClose={() => {
          setOpen(false)
          setDate(props.value || (props.range || props.week) && [undefined, undefined] || undefined)
        }}
        onAccept={date => {
          if (props.range) {
            let [startDate, endDate] = props.value || [undefined, undefined]
            if (!endDate && startDate && date.isSameOrAfter(startDate)) {
              endDate = date.format('YYYY-MM-DD')
            } else {
              startDate = date.format('YYYY-MM-DD')
              endDate = !props.range && startDate || undefined
            }
            if (endDate) {
              setOpen(false)
            }
          } else {
            setOpen(false)
          }
        }}
        label={props.inline ? '' : props.title}
        labelFunc={formatWeekSelectLabel}
        maxDate={props.maxDate}
        minDate={props.minDate}
        value={startD || moment()}
        renderDay={(props.range || props.week) && renderWrappedWeekDay}
        onChange={onChange}
        shouldDisableDate={props.disableDate && shouldDisableDate}/>
    {!props.disabled && ((props.range || props.week || props.year || props.month) && (startD && endD) || props.value) && props.clearDate !== false &&
    <i className={'ei-commun_fermer EurestoError--text cursor-pointer'}
       style={{position: 'absolute', right: 7.5, top: props.title && !props.inline && 18 || 9, zIndex: 1}} onClick={clearDate}/>}
  </Grid>

  return props.inline && <Grid container style={{margin: 0, padding: 0}} wrap={'nowrap'}>
        <Grid item style={{margin: 0, padding: 0, width: props.inlineWidth || 70, color: '#3E3E3E', lineHeight: .9}}>
          <Grid container style={{margin: 0, padding: 0, height: '100%'}} direction={'column'} justify={'center'}>
            {props.title || props.label}
          </Grid>
        </Grid>
        <Grid item xs style={{margin: 0, padding: 0, textAlign: 'left'}} className={'Euresto-InputInlineTitle'}>
          {datePicker}
        </Grid>
      </Grid>
      || datePicker
})



// WEBPACK FOOTER //
// ./app/Components/DatePicker.js